import dayjs from 'dayjs';
import React from 'react';
import { useDashboardPermissions } from '@components/utils/DashboardPermissions';
import { useAppearance } from '@fourthwall/appearance';
import { NumberString, getNumberString } from '@fourthwall/components';
import { Stat, mapChartToSeriesData, useMembershipsChartQuery } from '@fourthwall/module-analytics';
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop';
import { prepareSingleValueChart } from '@modules/Dashboard/pages/Analytics/pages/AnalyticsOverview/utils/prepareSingleValueChart';
import { useShopTime } from '@modules/Timezone/providers/ShopTimeProvider';
import { reverse, routing } from '@utils/routing';
import { getDateFormat, getFrom, getPrecision, getRangeQueryParam, getTo } from '../../utils';
export const MembersChangeChart = ({ range }) => {
    const { timezone, getCurrentShopTime, getCurrentRelativeShopTime } = useShopTime();
    const from = getFrom(getCurrentShopTime(), range);
    const to = getTo(getCurrentShopTime());
    const { appearance } = useAppearance();
    const { hasPermission } = useDashboardPermissions();
    const { currentShop } = useCurrentShop({ staleTime: Infinity });
    const { membershipsChartQuery: membersChangeQuery } = useMembershipsChartQuery([
        {
            from,
            to,
            precision: getPrecision(range),
            chartTypes: ['MEMBERS_CHANGE'],
            sid: [currentShop?.id],
            zoneId: timezone,
        },
    ]);
    const series = [
        {
            label: 'Members change',
            data: mapChartToSeriesData(prepareSingleValueChart(membersChangeQuery.data?.current.membersChange?.data), {
                from,
                to,
                precision: getPrecision(range),
            }, {
                allowPoints: false,
                now: getCurrentRelativeShopTime(),
            }),
        },
    ];
    const total = membersChangeQuery?.data?.current.membersChange?.aggregatedValue?.value || 0;
    const chartTo = hasPermission('analytics.membersChange')
        ? `${reverse(routing.analytics.overview.report.self, {
            reportType: 'memberships-members-change',
        })}?range=${getRangeQueryParam(range)}`
        : undefined;
    return (React.createElement(Stat, { appearance: appearance, label: "Members change", to: chartTo || '', loading: !membersChangeQuery.data || membersChangeQuery.isFetching, value: React.createElement(React.Fragment, null,
            total > 0 ? '+' : '',
            React.createElement(NumberString, { value: total })), chart: {
            formatDate: (date) => dayjs(date).format(getDateFormat(getPrecision(range))),
            formatValue: getNumberString,
            series,
        } }));
};
